<span
  [class]="!readonly() ? 'pointer' : ''"
  class="select-text truncate"
  [class.select-placeholder]="
    !selectedOption()?.element?.nativeElement?.innerHTML && !selectedOption()?.value()
  "
  [innerHTML]="
    displayedValue() ?? t('#UI_CORE.COMPONENTS.SELECT.PLACEHOLDER')() | secureHtml
  "
  (click)="onClick(); $event.stopPropagation(); $event.preventDefault()"
></span>

@if (isOpen()) {
  <div
    class="select-panel"
    [ngClass]="classSelectPanel()"
    (softClickOutside)="onOutsideClick()"
    [style.bottom]="openToTheTop() ? 'calc(100% + 0.25rem)' : ''"
    [style.top]="openToTheTop() ? 'auto' : ''"
    [style.transformOrigin]="openToTheTop() ? 'bottom' : ''"
    [delayClickOutsideInit]="true"
  >
    <div class="soft-scroll vertical select-panel-items" #panel>
      @for (option of options(); track option) {
        @if (isHeader(option)) {
          <div [id]="option.id()" class="select-option-header">
            {{ option.text() }}
          </div>
        }
        @if (isSeparator(option)) {
          <div [id]="option.id()" class="select-option-separator">
            <hr />
          </div>
        }
        @if (isOption(option)) {
          <div
            [id]="option.id()"
            class="select-option"
            [class.disabled]="option.disabled()"
            [class.pointer]="!option.disabled()"
            [class.selected]="option.value() === value()"
            [softScrollIntoView]="
              panel.scrollHeight > panel.clientHeight && value() === option.value()
            "
            [scrollBlock]="'nearest'"
            [scrollInline]="'nearest'"
            (click)="
              !option.disabled() ? onSelect(option.value()) : undefined;
              $event.stopPropagation();
              $event.preventDefault()
            "
            #currentDiv
          >
            @if (option.element.nativeElement.innerHTML || option.value()) {
              <span
                [innerHTML]="
                  option.element.nativeElement.innerHTML || option.value() | secureHtml
                "
              >
              </span>
            } @else {
              <span class="text-light">
                {{ '#UI_CORE.COMPONENTS.SELECT.EMPTY' | translate }}
              </span>
            }
          </div>
        }
      }
    </div>
  </div>
  <span class="soft-backdrop mobile-only z-300" (click)="onOutsideClick()"></span>
}

@if ((!readonly() && !openToTheTop() && isOpen()) || (openToTheTop() && !isOpen())) {
  <i
    class="fa-regular fa-chevron-up pointer"
    (click)="onClick(); $event.stopPropagation(); $event.preventDefault()"
  ></i>
} @else if (!readonly() || (openToTheTop() && isOpen())) {
  <i
    class="fa-regular fa-chevron-down pointer"
    (click)="onClick(); $event.stopPropagation(); $event.preventDefault()"
  ></i>
}
